import React from 'react'
import { AppBar, CssBaseline, Link, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faScaleUnbalancedFlip } from '@fortawesome/free-solid-svg-icons'
import HeaderMeasureSearchBar from './HeaderMeasureSearchBar'
import { ROUTES } from '../routes/routes'


const Header: React.FC = () => {
  const theme = useTheme()
  const lessThanMedium = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <React.Fragment>
      <CssBaseline/>
      <AppBar
        position={lessThanMedium ? 'relative' : 'sticky'}
        style={{
          background: theme.palette.custom.beautifulGradient
        }}>
        <Toolbar
            sx={{
                minHeight: { xs: '64px' },
                maxWidth: '1450px',
                width: '100%',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between'
            }}
        >
          <Link href={ROUTES.HOME} underline="none">
            <Typography
              component="h1"
              color="white"
              variant="h5"
              aria-label="Top Converters Website Icon and Title">
              <FontAwesomeIcon icon={faScaleUnbalancedFlip} style={{ fontSize: '1em' }} /> Top Converters
            </Typography>
          </Link>
          <HeaderMeasureSearchBar />
        </Toolbar>
      </AppBar>
    </React.Fragment>
  )
}

export default Header
